import React from "react"
import Navbar from "../../components/Navbar"
import DashboardContainer from "../Dashboard/DashboardContainer"
import UserImg from "../../assets/Images/tempImg/user.png"
import Card from "../../components/Card"
import EditButton from "../../components/Buttons/EditButton"
import ProfileCard from "../../components/Profile/ProfileCard"
import { InfoContainer } from "./component/InfoContainer"
import Headings from "../../components/Texts/Headings"

const EmploymentDetails = () => {
  const userDetails = {
    name: "Vikram Das",
    empType: "Self Employed",
    cmpName: "Vikram Das Pvt Ltd",
    cmpType: "Keshav Kunj, sector 26, Vashi, Navi Mumbai, Maharashtra",
  }

  const { name = "", cmpName = "", cmpType = "", empType = "" } = userDetails

  return (
    <>
      <Navbar isLoggedIn={true} />
      <DashboardContainer>
        <Headings
          text="Employment Details"
        />
        <ProfileCard
          UserImg={UserImg}
          name={name}
          docTitle={"Employment Type"}
          doc={empType}
        />
        <Card className="mt-[18px] max-w-[100%] md:max-w-[70%]">
          <div className="grid grid-cols-1 gap-[24px] ">
            <InfoContainer title="Company Name" value={cmpName} />
            <InfoContainer title="Company Type" value={cmpType} />
          </div>
        </Card>
      </DashboardContainer>
    </>
  )
}

export default EmploymentDetails
